import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_ncr_projects = async (page, limit, keyword, groupBy, filterPayload = '') => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/projects?page=${page}&limit=${limit}&keyword=${keyword}&groupBy=${groupBy}&filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_create_ncr = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_create_ncr_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_ncr_comment = async (page, limit, ncrId, filterPayload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/comment?page=${page}&limit=${limit}&ncrId=${ncrId}&filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_ncr = async (page, limit, shipId, filterPayload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr?page=${page}&limit=${limit}&shipId=${shipId}&filterPayload=${filterPayload}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_ncr_logs = async (page, limit, ncrId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/logs?page=${page}&limit=${limit}&ncrId=${ncrId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_ncr_Status_Update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/status`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_ncr_comment_change_favourite_status = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/favouriteUnfavourite/comment`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ncr_comment_reply = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/comment/reply`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ncr_comment_replies = async (ncrId, commentId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/comment/reply?ncrId=${ncrId}&commentId=${commentId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    });
};

export const v3_ncr_comment_status_update = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/comment/status`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};


export const v3_ncr_send_report_mail = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/reportMail`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};




